export const messages = {
  en: {
    communityManage: {
      queryTitle: 'Query Conditions',
      communityInfoTitle: 'Community Information',
      addCommunity: 'Add Community',
      editCommunity: 'Edit Community',
      communityId: 'Community ID',
      name: 'Community Name',
      nearbyLandmarks: 'Nearby Landmarks',
      cityCode: 'City Code',
      state: 'Status',
      area: 'Area',
      address: 'Address',
      confirmDeleteCommunity: 'Confirm to delete the community?',
      confirmRecallAudit: 'Confirm to recall the audit?',
      recallAudit: 'Recall Audit',
      recallAuditRemark: 'Recall audit',
      recallSuccess: 'Recall successfully',
      recallFailed: 'Recall failed',
      communityIdPlaceholder: 'Please enter community ID',
      namePlaceholder: 'Please enter community name',
      addressPlaceholder: 'Please enter community address',
      nearbyLandmarksPlaceholder: 'Please enter nearby landmarks',
      provincePlaceholder: 'Please select province',
      cityPlaceholder: 'Please select city',
      areaPlaceholder: 'Please select district',
      nameRequired: 'Community name is required',
      nameLength: 'Community name must be between 1 to 20 characters',
      addressRequired: 'Community address is required',
      addressMaxLength: 'Community address cannot exceed 200 characters',
      nearbyLandmarksRequired: 'Nearby landmarks is required',
      nearbyLandmarksMaxLength: 'Nearby landmarks cannot exceed 50 characters',
      communityIdRequired: 'Community ID is required'
    }
  },
  zh: {
    communityManage: {
      queryTitle: '查询条件',
      communityInfoTitle: '小区信息',
      addCommunity: '添加小区',
      editCommunity: '修改小区',
      communityId: '小区ID',
      name: '小区名称',
      nearbyLandmarks: '附近地标',
      cityCode: '城市编码',
      state: '状态',
      area: '地区',
      address: '地址',
      confirmDeleteCommunity: '确定删除小区？',
      confirmRecallAudit: '确定撤回审核？',
      recallAudit: '审核撤回',
      recallAuditRemark: '撤回审核',
      recallSuccess: '撤回成功',
      recallFailed: '撤回失败',
      communityIdPlaceholder: '请输入小区ID',
      namePlaceholder: '请输入小区名称',
      addressPlaceholder: '请输入小区地址',
      nearbyLandmarksPlaceholder: '请输入附近地标',
      provincePlaceholder: '请选择省',
      cityPlaceholder: '请选择城市',
      areaPlaceholder: '请选择区县',
      nameRequired: '小区名称不能为空',
      nameLength: '小区名称必须在1至20字符之间',
      addressRequired: '小区地址不能为空',
      addressMaxLength: '小区地址不能大于200个字符',
      nearbyLandmarksRequired: '附近地标不能为空',
      nearbyLandmarksMaxLength: '小区附近地标不能大于50个字符',
      communityIdRequired: '小区ID不能为空'
    }
  }
}